import { appConstants } from "../helpers/app-constants";

// let user = JSON.parse(localStorage.getItem("user"));
// const initialState = user ? { loggedIn: true, user } : {};
const initialState = {
  data: null,
  loading: false,
};

export function userBussinessInfomation(state = initialState, action) {
  switch (action.type) {
    case appConstants.LOADING_USER_BUSSINESS_INFORAMTION:
      return {
        ...state,
        loading: true,
      };

    case appConstants.GET_USER_BUSSINESS_INFORAMTION:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };

    case appConstants.LOADING_FAIL_USER_BUSSINESS_INFORAMTION:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}

export function userSubscriptionInfo(state = initialState, action) {
  switch (action.type) {
    case appConstants.LOADING_MY_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
      };

    case appConstants.GET_MY_SUBSCRIPTION:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };

    case appConstants.ERRORS_MY_SUBSCRIPTION:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}

const userListInitialState = {
  loading: false,
  data: {},
  errors: {},
};

export function userList(state = userListInitialState, action) {
  switch (action.type) {
    case appConstants.LOADING_USER_LIST:
      return {
        ...state,
        loading: true,
        data: {},
        errors: {},
      };

    case appConstants.GET_USER_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errors: {},
      };

    case appConstants.ERRORS_USER_LIST:
      return {
        ...state,
        loading: false,
        data: {},
        error: action.payload,
      };

    default:
      return state;
  }
}
